var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.49 19.6713H13.5V12.2283C13.5 11.6403 13.052 11.165 12.5 11.165H6.5C5.947 11.165 5.5 11.6403 5.5 12.2283V19.6713H2.5L2.506 10.7216L9.498 3.118L16.5 10.7652L16.49 19.6713ZM7.5 19.6711H11.5V13.2914H7.5V19.6711ZM17.924 9.23493L10.215 0.851947C9.838 0.44258 9.162 0.44258 8.785 0.851947L1.075 9.236C0.71 9.63473 0.5 10.1919 0.5 10.765V19.6711C0.5 20.8439 1.347 21.7977 2.388 21.7977H6.5H12.5H16.611C17.652 21.7977 18.5 20.8439 18.5 19.6711V10.765C18.5 10.1919 18.29 9.63473 17.924 9.23493Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.22959cee1b2829f37afa84f473098108.svg";
export { ForwardRef as ReactComponent };